import { render, staticRenderFns } from "./FileTransferForm.vue?vue&type=template&id=0ed56705&scoped=true&"
import script from "./FileTransferForm.vue?vue&type=script&lang=js&"
export * from "./FileTransferForm.vue?vue&type=script&lang=js&"
import style0 from "./FileTransferForm.vue?vue&type=style&index=0&id=0ed56705&prod&lang=css&"
import style1 from "./FileTransferForm.vue?vue&type=style&index=1&id=0ed56705&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed56705",
  null
  
)

export default component.exports